// extracted by mini-css-extract-plugin
export default {"root":"styles_root__457td","content":"styles_content__FhW7B","footText":"styles_footText__R7Tul"};